/**
 * eBASEデータ 出力用VOクラス
 */
export class KYMW1105OutputModel {
  public procDiv: string = <string>'';									// 処理区分(1:商品形態、2:JANコード、3:原産国加工地)
  public sizeLength: string = <string>'';									// サイズ(縦)
  public sizeWidth: string = <string>'';									// サイズ(横)
  public sizeHeight: string = <string>'';									// サイズ(高)
  public weight: string = <string>'';									// 重量
  public janCode: string = <string>'';									// ＪＡＮコード
  public textInfo_005: string = <string>'';									// 原産国加工地(005:主要原産地)
}
